import React from 'react'
import i18n from 'constants/strings'
import styles from './styles/search-results.module.scss'

const MAX_RESULTS_FOR_PRECISE_INFO = 1000

interface Props {
  loadedResults: number
  totalResults: number
  withDivider?: boolean
  isLoading?: boolean
}

const SearchResultsCounter = ({
  loadedResults = 0,
  totalResults = 0,
  withDivider = false,
  isLoading = false,
}: Props) => {
  const translationStr =
    totalResults <= MAX_RESULTS_FOR_PRECISE_INFO
      ? 'searchResults.tableResultsInfoWithTotal'
      : 'searchResults.tableResultsInfo'
  return (
    <>
      <p className={styles.pageCount}>
        {isLoading
          ? i18n.t('searchResults.searching')
          : i18n.t(translationStr, {
              showing: loadedResults ?? 0,
              total: totalResults ?? 0,
            })}
      </p>
      {withDivider && <div className={styles.resultsDivider} aria-hidden />}
    </>
  )
}

export default SearchResultsCounter
